





















import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      minValue: Math.max(this.$props.value[0], this.$props.min),
      maxValue: Math.min(this.$props.value[1], this.$props.max),
      isActive: !(this.$props.value[0] <= this.$props.min) || !(this.$props.value[1] >= this.$props.max),
    };
  },
  watch: {
    value(v) {
      const self: any = this;
      self.$data.minValue = v[0];
      self.$data.maxValue = v[1];
      self.$data.isActive = !(self.$props.value[0] <= self.$props.min) || !(self.$props.value[1] >= self.$props.max);
    },
    isActive(v: boolean) {
      if (!v) {
        (this as any).reset();
      }
    },
  },
  computed: {
    minForMax(): number {
      const self: any = this;
      return Math.max(self.$props.min, self.$data.minValue);
    },
  },
  methods: {
    reset() {
      this.$data.minValue = this.$props.min;
      this.$data.maxValue = this.$props.max;
      this.$data.isActive = false;
      this.$emit('input', [Number(this.$data.minValue), Number(this.$data.maxValue)]);
    },
    onChangeMin(e: any) {
      const val: number = Number(e.target.value);
      if (val < this.$props.min) {
        this.$data.minValue = this.$props.min;
      }
      if (val > this.$props.max) {
        this.$data.minValue = this.$props.max;
      }
      if (val > this.$data.maxValue) {
        this.$data.maxValue = this.$props.max;
      }
      this.$emit('input', [val, Number(this.$data.maxValue)]);
    },
    onChangeMax(e: any) {
      const val: number = Number(e.target.value);
      if (val < this.$props.min) {
        this.$data.maxValue = this.$props.min;
      }
      if (val > this.$props.max) {
        this.$data.maxValue = this.$props.max;
      }
      if (val < this.$data.minValue) {
        this.$data.minValue = this.$props.min;
      }
      this.$emit('input', [Number(this.$data.minValue), val]);
    },
  },
});
